// extracted by mini-css-extract-plugin
export default {"mainHolder":"TutorDetail_mainHolder__mXKVq","rowHolder":"TutorDetail_rowHolder__7Dr+i","paramHolder":"TutorDetail_paramHolder__Oudd+"};